function Schedule() {
  return (
    <section className="Schedule" aria-label="Schedule an appointment">
      <h2>Schedule an Appointment</h2>
      <div className="Schedule-info">
        <a href="tel:+17604462800">760-446-2800</a>
        <span className="Schedule-divider" aria-hidden="true">·</span>
        <a href="mailto:paul.mayberry@aol.com" target="_blank" rel="noopener noreferrer">
          paul.mayberry@aol.com
        </a>
      </div>
    </section>
  );
}

export default Schedule;
